import { graphql } from '../gql';

export const getCalendarEvents = graphql(`
  query GetCalendarEvents(
    $startTimeAfter: ISO8601DateTime
    $startTimeBefore: ISO8601DateTime
    $vendorIds: [ID!]!
  ) {
    searchEventVendors(
      input: {
        startTimeAfter: $startTimeAfter
        startTimeBefore: $startTimeBefore
        vendorIds: $vendorIds
        eventStatuses: [SCHEDULED, ACTIVE, IN_PROGRESS, COMPLETE, FINAL]
        perspective: RESTAURANT
        vendorStatuses: [ACTIVE]
      }
    ) {
      error {
        code
        message
      }
      eventVendors(first: 500) {
        nodes {
          __typename
          id
          productType
          ... on PopupEventVendor {
            confirmed
            siteDirectionsEmailSent
            vendor {
              id
              internalName
            }
            popupEvent {
              id
              startTime: eventStartTime
              endTime: eventEndTime
              status
              account {
                id
                name
              }
            }
            eventLocation {
              id
              setupTime
              serviceStartTime
              location {
                id
                name
                building {
                  id
                  name
                }
              }
            }
          }
          ... on SelectEventVendor {
            aggregateManifestKey
            foodDelivered
            vendor {
              id
              internalName
            }
            preManifestDocument {
              id
              status
              manifestDate
            }
            finalManifestDocument {
              id
              status
              manifestDate
            }
            selectEvent {
              id
              startTime: endTime
              endTime: deliveryTime
              status
              readyAndBaggedTime
              mealPeriod
              account {
                id
                name
              }
              location {
                id
                name
                building {
                  id
                  name
                }
              }
            }
          }
          ... on CateringEventVendor {
            vendor {
              id
              internalName
            }
            event {
              id
              startTime
              endTime
              status
              name
              mealPeriod
              setupTime
              account {
                id
                name
              }
              location {
                id
                name
                building {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`);
